export const XXL_DESKTOP_BREAKPOINT = 1920
export const XL_DESKTOP_BREAKPOINT = 1600
export const DESKTOP_BREAKPOINT = 1200
export const LAPTOP_BREAKPOINT = 992
export const TABLET_BREAKPOINT = 768
export const MOBILE_BREAKPOINT = 480
